export enum DataTable {
  CACHE = 'CACHE',
  STORAGE = 'STORAGE',
  ASSETS = 'ASSETS',
}

export type StoreName = `${DataTable}`;
